import React, { Component } from 'react';
import { Button, Card, Col, DatePicker, Divider, Form, message, Row, Table } from 'antd';
import { Link } from 'react-router';

import moment from 'moment';
import util from '@util/index';
import DescriptionList from '@comm/DescriptionList';
import { BackBtn } from '@comm/BackBtn';
import {
  queryBackAllWage,
  queryBackWage,
  querySendAllWage,
  querySendWage,
  queryWageDetailList,
  queryWageStaticComMonth,
} from '@api/hr/wage';

const FormItem = Form.Item;
const { MonthPicker } = DatePicker;
const { Description } = DescriptionList;

class PageMonthCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      total: 0,
      pageNo: 1,
      staticData: {},
      sendAllLoading: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  getParams = () => {
    const {
      params: { uuid },
    } = this.props;
    const { date } = this.props.form.getFieldsValue();
    return {
      year: moment(date).format('YYYY'),
      month: moment(date).format('MM'),
      companyUuid: uuid,
    };
  };

  wageStaticComMonth = () => {
    queryWageStaticComMonth(this.getParams()).then(res => {
      this.setState({
        staticData: res.data,
      });
    });
  };

  wageDetailList = pageNo => {
    const params = {};
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    queryWageDetailList({
      ...this.getParams(),
      ...params,
    }).then(res => {
      this.setState({
        data: res.data,
        total: res.totalSize,
      });
    });
  };

  loadData = () => {
    this.wageStaticComMonth();
    this.wageDetailList();
  };

  handleSearch = e => {
    e.preventDefault();
    this.loadData();
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form layout="inline" style={{ textAlign: 'right' }} onSubmit={this.handleSearch}>
        <FormItem>
          {getFieldDecorator('date', {
            initialValue: moment(
              moment.unix(new Date().getTime() / 1000).format('YYYY-MM'),
              'YYYY-MM',
            ),
          })(<MonthPicker format="YYYY-MM" />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" style={{ marginRight: '-16px' }}>
            查询
          </Button>
        </FormItem>
      </Form>
    );
  };

  wageSend = uuid => {
    querySendWage({
      uuids: [uuid],
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.wageDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  wageBack = uuid => {
    queryBackWage({
      uuids: [uuid],
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.wageDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  wageBackAll = () => {
    const params = this.getParams();
    queryBackAllWage(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.wageDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  wageSendAll = () => {
    const params = this.getParams();
    this.setState({
      sendAllLoading: true,
    });
    querySendAllWage(params).then(res => {
      this.setState({
        sendAllLoading: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.wageDetailList();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '发放年度',
        dataIndex: 'year',
      },
      {
        title: '发放月份',
        dataIndex: 'month',
      },
      {
        title: '姓名',
        dataIndex: 'name',
      },
      {
        title: '人力成本',
        dataIndex: 'hrCost',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '税后工资',
        dataIndex: 'incomeAfterTax',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '现金发放工资',
        dataIndex: 'cashPayment',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '银行发放工资',
        dataIndex: 'bankPayment',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '导入日期',
        dataIndex: 'createTime',
        render: text => <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <span>
              <Link to={`/hr/wage/detail/${record.uuid}`}>查看</Link>
              <Divider type="verticle" />
              {record.isSendFlag ? null : (
                <a onClick={() => this.wageSend(record.uuid)}>发送工资条</a>
              )}
              {!record.isReadFlag && record.isSendFlag ? (
                <a onClick={() => this.wageBack(record.uuid)}>收回</a>
              ) : null}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, total, staticData } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.wageDetailList(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div>
          <Row>
            <Col span={6}>
              <BackBtn />
            </Col>
            <Col span={18}>{this.renderSearchForm()}</Col>
          </Row>
        </div>
        <Divider />
        <div>
          <DescriptionList size="large" style={{ marginBottom: 32 }} col={3}>
            <Description term="公司名称">{staticData.companyName}</Description>
            <Description term="当月人力成本">
              {util.numberFormat(staticData.hrCost, 2, '.', ',')}元
            </Description>
            <Description term="员工人数">{staticData.hrCount}</Description>
            <Description term="当月税后工资">
              {util.numberFormat(staticData.incomeAfterTax, 2, '.', ',')}元
            </Description>
            <Description term="当月现金发放工资">
              {util.numberFormat(staticData.cashPayment, 2, '.', ',')}元
            </Description>
            <Description term="当月银行发放工资">
              {util.numberFormat(staticData.bankPayment, 2, '.', ',')}元
            </Description>
          </DescriptionList>
        </div>
        <div className="tableList" style={{ textAlign: 'right' }}>
          <Button
            style={{ margin: '0 8px 16px 0' }}
            type="primary"
            onClick={() => this.wageSendAll()}
            loading={this.state.sendAllLoading}
          >
            发送全部工资条
          </Button>
          <Button onClick={() => this.wageBackAll()}>全部撤回</Button>
        </div>
        <Table rowKey="uuid" columns={this.columns()} dataSource={data} pagination={pagination} />
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(PageMonthCompany);



// WEBPACK FOOTER //
// ./src/components/hr/wage/PageMonthCompany.js